import { render, staticRenderFns } from "./EPDashboardComponent.vue?vue&type=template&id=6d31672e&"
import script from "./EPDashboardComponent.vue?vue&type=script&lang=js&"
export * from "./EPDashboardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports